export const feature_flag_interceptor_management =
  'ih-3760-interceptor-management';
